<page-loader *ngIf="isLoading"></page-loader>
<div id="page-badges" *ngIf="!isLoading">
    <div class="app-l-badges__banner">
        <div class="app-l-badges__over app-l-container">
            <h2 translate>badges.title</h2>
            <p translate>badges.badgesCardDesc</p>
            <p translate>badges.badgesCardDescMore</p>
        </div>
    </div>

    <div class="app-l-page-wrap">
        <div class="app-l-badges-wrap">
            <div
                class="app-l-badges-grid"
                *ngIf="badges && badges.length > 0">
                <div class="badge-image-container" *ngFor="let badge of badges">
                    <div
                        class="badge-image-wrapper"
                        [class.not-earned]="!badge.earnedOn">
                        <img
                            [src]="badge.imagePath"
                            [alt]="badge.name"
                            class="badge-img"
                            (error)="handleImageError(badge)" />
                        <div
                            class="download-icon"
                            *ngIf="badge.earnedOn"
                            (click)="downloadBadge(badge, $event)">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24">
                                <path
                                    d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                            </svg>
                            <span class="download-badge-text" translate>badges.downloadBadge</span>
                        </div>
                    </div>
                    <div class="badge-earned-info">
                        <div class="badge-user">{{ badge.earnedOn ? userName : '&nbsp;' }}</div>
                        <div class="badge-earned-date">{{ badge.earnedOn ? (badge.earnedOn | date: 'MM-dd-yyyy') : '&nbsp;' }}</div>
                    </div>
                </div>
            </div>

            <!-- Empty state - only show if badges are empty -->
            <div *ngIf="!isLoading && (!badges || badges.length === 0)" class="app-l-no-badges">
                <h5 class="app-c-body-text--16-m" translate>badges.empty</h5>
            </div>
        </div>
    </div>
</div>
